import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type { IRemoveDocumentReaderUploadFileResponse } from './types';

/** Removes one file from an upload that has not been read; the answer carries the lowered counts. */
export async function removeDocumentReaderUploadFile(
  uploadId: string,
  fileId: string,
  signal?: AbortSignal
): Promise<CommendaAiMutationResult<IRemoveDocumentReaderUploadFileResponse>> {
  return AgentApiRequestHelper.mutate<IRemoveDocumentReaderUploadFileResponse>(
    `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}/files/${encodeURIComponent(fileId)}/remove`,
    { method: 'POST', ...(signal ? { signal } : {}) },
    'Could not remove this document.'
  );
}
